module.exports = __webpack_public_path__ + "static/media/Portrait-10182.59f9b2b4.jpg";